import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, isPublic = false, ...rest }) => {
  const { isAuth, loading } = useContext(AuthContext);

  if (loading) {
    return <BackdropLoading />;
  }

  if (isPublic) {
    return <RouterRoute {...rest} component={Component} />;
  }
  
  if (!isAuth && isPrivate) {
    return <Redirect to="/login" />;
  }

  if (isAuth && !isPrivate) {
    return <Redirect to="/" />;
  }

  return <RouterRoute {...rest} component={Component} />;
};

export default Route;